import { CallServices, CoreServices, MeetServices, ReportServices, SocialmediaServices, WhatsappService } from "./apiServices";
import { ClearStorage, GetItemFromStorage, SetItemInStorage } from "../../custom_hooks/useStorage";
import { Cookie, MapAgentTrackerData, isJSON } from "../utils";
import { AgentStateAction } from "../../store/slices/agent-status/agent_state";
import { ChatActions } from "../../store/slices/chat_slice/chat_slice";
import { GetAlluserActions } from "../../store/slices/user_management/get_all_users";
import { LocalStorage } from "../../custom_hooks/localStorageKeys";
import _, { isEmpty } from "lodash";
import { agentTrackerActions } from "../../store/slices/trackerStatus_slice/agentTrackerslice";
import { config, DOMAINID, ROLES } from "../constant";
import jwt_decode from "jwt-decode";
import store from "../../store/redux-store/root_store";
import { queueTrackerActions } from "../../store/slices/trackerStatus_slice/queueTrackerslice";
import socketIOClient from "socket.io-client";
import { getAllUsers } from "../../store/api/user_management";
import { agentstatusListAction } from "../../store/slices/agent-status/agent-status";
import { meetActionTypes } from "../action/action";
import { CallPopUpAgentActions } from "../../store/slices/voice_call_slice/call_popup_agent";
import callChatService from "./chatService";
import { getLiveSessions } from "../../components/contact/base/utils";
import { dashBoardSliceActions } from "../../store/slices/dashboard_slice/dashBoard";

export default class presenceService {
    public static io: any;
    static _instance: any;
    private static hist: any;
    constructor(token: any, navigate: any, dispatch: any,key:any) {
        let userData: any = jwt_decode(token);
        const LoginCcaasUserDetails = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
        presenceService.io = socketIOClient(config().BASE_URL, {
            // presenceService.io = socketIOClient("http://localhost:3010", {
            path: "/presence-service",
            auth: { token: token, id: `${userData?.domainId}_${userData?.ext}` },
            transports: ["websocket"],
        });

        let force_pre: any = key;

        presenceService.io.on('connect', () => {
            console.log('socket connected');
            console.log('presenceService userData--->', userData);
            // const agentStatus: any = store.getState().agentStatus;
            const popUpDetails: any = store.getState().callPopUpDetails;
            let { incomingCallDetail } = popUpDetails;
            // if (agentStatus?.socketDisconnectStatus === true) {
            const { currentStatus, agentStatus } = store.getState().agentState;
            const presence = sessionStorage.getItem('presence')
            const currentPresence = (presence === "" || !presence) ? "Not Ready" : presence

            const { users } = store.getState().userList;
            SetItemInStorage("WORK_STATUS_COLOR", currentStatus?.colorCode);
            let status: any = null
            if (agentStatus?.length > 0) {
                [status] = agentStatus?.filter((i: any) => { return currentPresence?.trim() === i?.statusName?.trim() })
            }
            let enableStatus: any = null
            if (users.length > 0) {
                [enableStatus] = users?.filter((i: any) => { return LoginCcaasUserDetails?.emailId === i?.emailId })
            }
            console.log('presenceService 1 socket connected', status,users, enableStatus,"popUpDetails?.incomingCallDetail ",popUpDetails?.incomingCallDetail , LoginCcaasUserDetails?.emailId);
            presenceService?.io?.emit("updatestate_backend", {
                domainId: userData?.domainId,
                isVoice: (enableStatus?.voice === 1 && status?.isVoice === 1 && (popUpDetails?.incomingCallDetail ? Object.keys(popUpDetails?.incomingCallDetail ?? {}).length : 0) === 0) ? 1 : 0,
                isVoiceCallTransfer: status?.isVoiceCallTransfer ?? 0,
                isChat: (enableStatus?.chat === 1 && status?.isChat === 1) ? 1 : 0,
                isChatTransfer: status?.isChatTransfer ?? 0,
                isEmail: (enableStatus?.email === 1 && status?.isEmail === 1) ? 1 : 0,
                isEmailTransfer: status?.isEmailTransfer ?? 0,
                stateTime: Math.floor(Date.now() / 1000),
                statusName: currentPresence,
                ext: userData?.ext,
                email: userData?.Email,
                agentStatus: Object.keys(incomingCallDetail)?.length > 0 ? 0 : 1,
                userId: LoginCcaasUserDetails?.UserID,
                routingProfileId: LoginCcaasUserDetails?.routing_profile_id,
                roleId: LoginCcaasUserDetails?.roleid,
                skill: JSON.parse(enableStatus?.addSkill ?? '[]'),
                routingMethod: enableStatus?.routingMethod ?? 0,
                inboundCall: enableStatus?.inboundCall,
                outboundCampaignCall: enableStatus?.outboundCampaignCall,
                is_outbound_campaign_specific_agent: enableStatus?.is_outbound_campaign_specific_agent,
                // forced_presence: (popUpDetails?.incomingCallDetail ? Object.keys(popUpDetails?.incomingCallDetail ?? {}).length : 0) === 0 ? 1 :0
                forced_presence: force_pre?? 0
                
            });
            force_pre = 0;

            let data = {
                ext: userData?.ext,
                domainId: userData?.domainId
            };
            callChatService.io.emit("agent_ready_for_queue_users", data);
            dispatch(agentstatusListAction.setSocketDisconnectStatus(false))
            let body: any = {
                state: status?.aid ?? 0,
                timestamp: Date.now(),
            };

            CallServices.post(body, `/create_state`);
            WhatsappService.post(data, `/send_agent_status_queue`);
            SocialmediaServices.post(data, `/send_agent_status_queue_facebook`);
            SocialmediaServices.post(data, `/send_agent_status_queue_instagram`);
            // }
        });

        presenceService.io.on("reconnect", () => {
            // console.log("socket", `${userData?.domainId}_${userData?.ext}`);
            console.log("socket reconnect");
        });
        presenceService.io.on('disconnect', () => {
            dispatch(agentstatusListAction.setSocketDisconnectStatus(true))
            console.log('socket disconnect')
        });

        presenceService.io.on("connect_error", (msg: any) => {
            if (msg && msg?.message && isJSON(msg?.message)) {
                const parsedMessage: any = JSON.parse(msg?.message);
                if (parsedMessage?.code === 403) {
                    Cookie.clear();
                    navigate("/login");
                    ClearStorage();
                    localStorage.clear();
                    sessionStorage.clear();
                    presenceService.destroy();
                }
            }
        });

        presenceService.io.on("connect", (message: any) => {
            dispatch(ChatActions.updateSocketConnect());
        });

        presenceService.io.on("updatedstatus", (data: any) => {
            const userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
            if (userDetails?.ext?.toString() === data?.ext?.toString() && userDetails?.domainId?.toString() === data?.domainId?.toString()) {
                dispatch(AgentStateAction.setCurrentStatus({ status: data?.statusName }));
            }
        });

        presenceService.io.on("userStatusUpdated", async (data: any) => {
            try {
                let userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
                if (data?.email && data?.status) {
                    let setData = { email: data?.email ?? "", status: data?.status ?? "Offline" };
                    dispatch(agentTrackerActions.updateUserInAgentTracker(setData));
                    dispatch(GetAlluserActions.updateStatus(setData));
                }
    
                if (parseInt(userDetails?.domainId) === parseInt(data?.domainId) && !DOMAINID.includes(data?.domainId)) {
                    CallServices.get("/get_all_queue_wait_time").then((resp: any) => {
                        dispatch(
                            queueTrackerActions.queueTrackerData({
                                queueTrackerData: resp.data.getAllQueueList,
                            })
                        );
                    });
    
                    CoreServices.get(`/get_all_user_list`).then((resp: any) => {
                        let dataValue: any = "";
                        const userRoleId = GetItemFromStorage(LocalStorage.ROLE_ID);
                        if (userRoleId != ROLES.AGENT_ROLE_ID) {
                            dataValue = resp.data.getAllUserList;
                            let result = MapAgentTrackerData(dataValue, userRoleId?.toString());
                            dispatch(
                                agentTrackerActions.updateAgentTrackerData({
                                    agentTrackerData: result,
                                })
                            );
                        }
                        dispatch(
                            agentTrackerActions.updateAgentList({
                                agentList: resp.data.getAllUserList,
                            })
                        );
                    });
                    const userRoleId = GetItemFromStorage(LocalStorage.ROLE_ID);
                    if (userRoleId != ROLES.AGENT_ROLE_ID) {
                    ReportServices.get("/get_dashboard_agent_status/0").then((response: any) => {
                        if (response.data.statusCode === 200) {
                            dispatch(dashBoardSliceActions.agentData(response.data.getChatLiveDashboardDetails))
                        }
                    });}
                    dispatch(getAllUsers());
                    if(userRoleId == ROLES?.ADMIN_ROLE_ID || userRoleId ==  ROLES?.SUPERVISOR_ROLE_ID){
                        await getLiveSessions(dispatch);
                    }
                }
            } catch (error) {
                console.log("userStatusUpdated error",error)
            }
       
        });

        presenceService.io.on("inviteVideoRequest", (data: any) => {
            console.log(data, "inviteVideoRequest=======", data);
            const ringer: any = document.getElementById("ringer");
            store.dispatch({
                type: meetActionTypes.VM_TRANSFER,
                payload: {
                    vmTransferDropdown: false,
                    vm_acd_event: data.acd_event,
                    vmTransfer: false,
                    vmTransferDetails: {}
                }
            })
            if (data.acd_event === 2 || data.acd_event === 5) {
                try {

                    console.log("close poppup after 30 sec");

                    dispatch(CallPopUpAgentActions.videoAttendedCall({ videoacceptCallRoom: false }));
                    ringer.pause();
                }
                catch (e: any) {
                    console.log("acd_event error>>>", e)
                }
            } else {
                try {
                    MeetServices.get(data.session_id, `get_agent_meeting`).then((res: any) => {
                        if (res.data.statusCode === 200 && res.data.hasOwnProperty("data") && res.data.data) {
                            console.log(res, "res get meet========")
                            store.dispatch({
                                type: meetActionTypes.UPDATE_MEET_DETAILS,
                                payload: {
                                    meetingDetails: res?.data.data.meetingDetails
                                }
                            });
                        }

                    });
                    dispatch(CallPopUpAgentActions.videoAttendedCall({ videoacceptCallRoom: true }));
                    let videoCallDetails :any=store.getState().meetingReducer.videoCallDetails;
        let updatedInfo: any = videoCallDetails;
            updatedInfo = {
                ...updatedInfo, callId:data.call_id
            };
            store.dispatch({
              type: meetActionTypes.VIDEO_CALL_DETAILS,
              payload: {
               videoCallDetails:updatedInfo
              }
            });
                    let ringer: any = document.getElementById("ringer");
                    console.log(ringer, "ringer");
                    var promisesRing: any = ringer.play();
                    if (promisesRing !== undefined) {
                        promisesRing.then(() => {
                            ringer.play();
                        })
                            .catch((error: any) => {
                                ringer.play();
                            });
                    }
                }
                catch (e: any) {
                    console.log("meeting ringing notification error>>", e);
                }
            }
        });
    }

    static async destroy() {
        presenceService?.io?.disconnect();
    }
}
